import React, { useEffect, useState, useContext } from "react";
import { Link, useHistory, useNavigate, useLocation } from "react-router-dom";
import { RedirectCode400 } from "../../RedirectCode400";
import { CurrentUserContext } from "../../../App";
import * as AdminApi from "../../../service/adminApi";
import PageHeaderV2 from "../../pageheaderV2/PageHeaderV2";
import "moment/locale/th";
import DialogTailwindConfirm from "../../DialogTailwindConfirm";
import TableSearchV1 from "../../tableV1/tableSearchV1";
import { FaCircle, FaTrash } from "react-icons/fa";
import format from "date-fns/format";

export default function Petition() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const userAuthCurrent = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [selectedData, setSelectedData] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [userDataList, setUserDataList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  const [filters, setFilters] = useState({
    "petitioner.fname": "",
    "petitioner.lname": "",
    phone_number: "",
    hospital_name: "",
    status: "PENDING",
    "create_date.date": "",
  });
  const [sortBy, setSortBy] = useState({ id: "", desc: false });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    getDataList();
  }, [page, filters, sortBy]);

  const optionStatusList = [
    {
      name: "รอดำเนินการ",
      value: "PENDING",
    },
    {
      name: "ดำเนินการแล้ว",
      value: "FINISH",
    },
  ];

  const getDataList = async () => {
    setLoading(true);
    const res = await AdminApi.getPetitionList(
      page,
      10,
      filters,
      formatDate(filters["create_date.date"]),
      sortBy.id,
      sortBy.id ? (sortBy.desc ? "desc" : "asc") : "",
    );

    setLoading(false);
    if (res) {
      if (res.data.code === 200) {
        setUserDataList(res["data"]["petition_list"]);
        setTotal(res.data.amount);
        setMaxPage(Math.ceil(res.data.amount / 10));
      } else if (res.data.code === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res.data.message_th || res.data.message,
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  // ฟังก์ชันเปิด dialog พร้อมบันทึกข้อมูล row ที่ต้องการ
  const openDialog = (rowData) => {
    setSelectedData(rowData);
    setIsDialogOpen(true);
  };

  //เปิด Dialog
  const handleConfirm = async (confirmed, data) => {
    setIsDialogOpen(false);
    if (confirmed && data) {
      if (data?.petition_id) {
        let res = await AdminApi.setPetitionFinish(data?.petition_id);

        if (res) {
          if (res["data"]["code"] === 200) {
            setIsMessage({
              type: "success",
              data: res["data"]["message_th"] || res["data"]["message"],
            });
            getDataList(page, 10, "PENDING");
          } else if (res["data"]["code"] === 403) {
            navigate(RedirectCode400());
          } else {
            setIsMessage({
              type: "warning",
              data: res["data"]["message_th"] || res["data"]["message"],
            });
          }
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }
      }
    }
  };

  const handleRemoveDocument = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item.petitioner.fname} ใช่หรือไม่`))
      return;

    setLoading(true);
    try {
      const res = await AdminApi.removePetition(item["petition_id"]);
      if (res?.data?.code === 200) {
        getDataList();
      } else {
        setIsMessage({
          type: "warning",
          data: res?.data?.message_th || res?.data?.message,
        });
      }
    } catch (error) {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    return format(date, "yyyy-MM-dd");
  };

  const formatDateThai = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  const handleSortChange = (id, desc) => {
    setPage(1);
    setSortBy({ id, desc });
  };

  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "ชื่อ",
      accessor: "petitioner.fname",
      Filter: "text",
    },
    {
      Header: "นามสกุล",
      accessor: "petitioner.lname",
      Filter: "text",
    },
    {
      Header: "เบอร์โทร",
      accessor: "phone_number",
      Filter: "text",
    },
    {
      Header: "โรงพยาบาลที่เคยตรวจ",
      accessor: "hospital_name",
      // DataFilter: optionRoleList,
      Filter: "text",
    },
    {
      Header: "สถานะ",
      accessor: "status",
      DataFilter: optionStatusList,
      Filter: "select",
      Cell: (row) => (
        <div>
          {row.value === "FINISH" ? (
            <div className="flex justify-center items-center">
              <div style={{ color: "#64BD86", fontSize: "14px" }}>
                ดำเนินการแล้ว
              </div>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <button
                onClick={() =>
                  openDialog({
                    message: `กรุณายืนยันการทำรายการ คุณกำลัง อนุมัติ ผู้ใช้งาน ${row.row.original.petitioner.fname} ${row.row.original.petitioner.lname} ใช่หรือไม่ `,
                    petition_id: row.row.original.petition_id,
                  })
                }
                className="button-theme-pg p-0 flex justify-center items-center w-[120px] h-[30px] bg-[#BEBEBE] text-[#FFFFFF] rounded-3xl gap-1 shadow-sm shadow-my-gray "
              >
                รอดำเนินการ
              </button>
            </div>
          )}
        </div>
      ),
    },
    {
      Header: "วันที่ทำรายการ",
      accessor: "create_date.date",
      Cell: ({ row }) => {
        const createdDate =
          row.original.create_date && row.original.create_date.date
            ? row.original.create_date.date
            : null;
        return createdDate ? formatDateThai(createdDate) : "";
      },
      Filter: "date",
    },
    {
      Header: "#",
      disableSortBy: true,
      accessor: "actions",
      Cell: ({ row }) => {
        const i = row.original;

        return (
          <div className="flex flex-row justify-center items-center gap-[6px]">
            <button
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#FCD8DB 0% 0% no-repeat padding-box" }}
              onClick={() => handleRemoveDocument(i)}
            >
              <FaTrash className="text-[#D32736] h-[14px]" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div>
        <div className="mt-[60px]"></div>
        <div>
          <PageHeaderV2 titlename="รายชื่อผู้ป่วยแจ้งตรวจสอบข้อมูล" />
          <TableSearchV1
            columns={columns}
            data={userDataList}
            filters={filters}
            setFilters={setFilters}
            loading={loading}
            total={total}
            page={page}
            maxPage={maxPage}
            setPage={setPage}
            sortBy={sortBy}
            onSortChange={handleSortChange}
            noDataComponent={
              <div className="w-full text-left">ไม่พบข้อมูล</div>
            }
          />
        </div>
      </div>
      {/* เปิด DialogTailwindConfirm พร้อมส่งข้อมูล row ที่เลือก */}
      {isDialogOpen && selectedData && (
        <DialogTailwindConfirm
          onConfirm={handleConfirm}
          onCancel={handleConfirm}
          data={selectedData}
        />
      )}
    </>
  );
}
